/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import type { Provider } from "@ethersproject/providers";
import type {
  ITreasuryModuleFactory,
  ITreasuryModuleFactoryInterface,
} from "../../../../contracts/mocks/treasury/ITreasuryModuleFactory";

const _abi = [
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class ITreasuryModuleFactory__factory {
  static readonly abi = _abi;
  static createInterface(): ITreasuryModuleFactoryInterface {
    return new utils.Interface(_abi) as ITreasuryModuleFactoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ITreasuryModuleFactory {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as ITreasuryModuleFactory;
  }
}
